import { WaitingList } from '../WaitingList/WaitingList'
import type { WaitingListSource } from '@/modules/marketingAnalytics'

export const HomePageWaitingList = ({ source }: { source: WaitingListSource }) => (
  <div className="pt-2">
    <WaitingList source={source} />
  </div>
)
